import React from 'react';
const Slider = () => {
    return React.createElement(React.Fragment, null, "slider");
};
export default Slider;
